const FULL_INCOME_MAX_DOC_LEVEL = 2;
const FULL_INCOME = "100";
const ALTERNATIVE_INCOME = "70";
const getDefaultNonQMDocLevel = (docTypeIncome) => {
  if (docTypeIncome === FULL_INCOME) return "1";
  if (docTypeIncome === ALTERNATIVE_INCOME) return "3";
  return void 0;
};
const isNonQMDocLevelValidForIncome = (nonQMDocLevel, docTypeIncome) => {
  if (!nonQMDocLevel || !/^\d+$/.test(String(nonQMDocLevel))) return false;
  const isFullIncomeLevel = Number(nonQMDocLevel) <= FULL_INCOME_MAX_DOC_LEVEL;
  if (docTypeIncome === FULL_INCOME) return isFullIncomeLevel;
  if (docTypeIncome === ALTERNATIVE_INCOME) return !isFullIncomeLevel;
  return !isFullIncomeLevel;
};
export {
  getDefaultNonQMDocLevel,
  isNonQMDocLevelValidForIncome
};
